import React from 'react';
import { Paper, Typography } from '@mui/material';

function About() {
  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        About Our Campaign
      </Typography>
      <Typography paragraph>
        We're fighting for better working conditions, fair pay, and stronger support for teachers across the district.
      </Typography>
      <Typography paragraph>
        With 15 years of experience in education and successful union leadership, Richard Otieno is committed to making real change.
      </Typography>
    </Paper>
  );
}

export default About; 